import React, { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import {
  BrowseCallback,
  BrowseCallbackError,
  BrowseLogin,
  BrowseLogout,
  BrowsePasswordless,
  BrowseResetPassword,
} from './views'
import { setupNewRelic } from './utils/newrelic'

import styles from './App.scss'

export default function App() {
  useEffect(() => {
    setupNewRelic()
  }, [])

  return (
    <>
      <Header />
      <main className={styles.main}>
        <Routes>
          <Route path="/create-account" element={<BrowseLogin initialScreen="registration" />} />
          <Route path="/register" element={<BrowseLogin initialScreen="registration" />} />
          <Route path="/sign-in" element={<BrowseLogin initialScreen="login" />} />
          <Route path="/sign-out" element={<BrowseLogout />} />
          <Route
            path="/my-account/create-password"
            element={<BrowseLogin initialScreen="request_reset_password" />}
          />

          <Route path="/sso/browse/callback/error" element={<BrowseCallbackError />} />
          <Route path="/sso/browse/callback" element={<BrowseCallback />} />
          <Route path="/sso/browse/login" element={<BrowseLogin />} />
          <Route path="/sso/browse/logout" element={<BrowseLogout />} />
          <Route path="/sso/browse/passwordless/end" element={<BrowsePasswordless />} />
          <Route path="/sso/browse/reset-password/end" element={<BrowseResetPassword />} />
        </Routes>
      </main>
      <Footer />
    </>
  )
}
